var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('div',{staticClass:"app-content"},[_c('div',{class:['content-wrapper',
                        this.inSearch ? 'full-width' : '',
                        this.showMessage ? 'messageOffset' : 'noMessageOffset']},[_c('router-view')],1)]),_c('div',{class:['footer-wrapper', this.inSearch ? 'hidden' : '']},[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }